import { useQuery } from "@tanstack/react-query";
import { FlowEntryGrid } from "@/components/navigate-to-mass-update-flow/FlowEntryGrid";
import { DraftBanner } from "@/components/shared/draft-banner";
import { ErrorState } from "@/components/shared/error-state";
import { PageHeader } from "@/components/shared/page-header";
import { Skeleton } from "@/components/ui/skeleton";
import {
  fetchMassUpdateFlows,
  navigateToMassUpdateFlowKeys,
} from "@/mocks/navigate-to-mass-update-flow";

const SKELETON_CARDS = ["a", "b", "c", "d"];

export function NavigateToMassUpdateFlowPage() {
  const {
    data: flows,
    isLoading,
    isError,
    refetch,
  } = useQuery({
    queryKey: navigateToMassUpdateFlowKeys.all,
    queryFn: fetchMassUpdateFlows,
  });

  return (
    <div className="space-y-6">
      <DraftBanner
        epic="EPIC-001"
        run="HR-001"
        subtitle="Mass Update home — pick a flow to work in."
      />
      <PageHeader
        title="Mass Update"
        description="Change many Sales Orders or Work Orders at once, instead of one at a time in NetSuite."
      />
      {isError ? (
        <ErrorState message="Couldn't load the flow list." onRetry={() => refetch()} />
      ) : isLoading || !flows ? (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {SKELETON_CARDS.map((key) => (
            <Skeleton key={key} className="h-44 w-full rounded-xl" />
          ))}
        </div>
      ) : (
        <FlowEntryGrid flows={flows} />
      )}
    </div>
  );
}
